/* Teeez 3.67: product page
   1. Price inside the Add to bag button, updated per shade (sale price shows the old price struck through).
   2. Shade label "Shade: Please Me, rich berry" instead of Swatch King's "Select a Lust Lipstick".
   3. First photo: never a sold out shade; after picking a shade the first photo becomes that shade.
   4. Save with sets follows the chosen shade (photo, "Starts with", link).
   5. Mobile: a slim bar with the shade and the button, only while the real button is out of view.
   6. Bundle pages opened from a set link pick the shade from ?teeez_shade=. */
(() => {
  const start = () => {
    const tag = document.getElementById('teeez-pdp-data');
    if (!tag || tag.dataset.ready) return;
    tag.dataset.ready = 'true';
    let D;
    try { D = JSON.parse(tag.textContent); } catch (e) { return; }
    const root = document.querySelector('.product-page--root');
    if (!root) return;
    const select = root.querySelector('select[name="id"]');
    const cta = root.querySelector('.product-buy-buttons--cta');
    const ids = Object.keys(D.variants || {});
    const current = () => (select && D.variants[select.value]) || null;
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    /* products with one variant: no swatch row (Swatch King shows a single chip there) */
    if (!D.bundle && ids.length === 1) {
      const hideSk = () => root.querySelectorAll('variant-swatch-king').forEach((el) => { el.style.display = 'none'; });
      hideSk();
      setTimeout(hideSk, 800);
      setTimeout(hideSk, 2500);
    }

    /* 1. price in the button */
    let priceEl = null;
    if (cta) {
      priceEl = document.createElement('span');
      priceEl.className = 'teeez-cta-price';
      const textEl = cta.querySelector('.product-buy-buttons--cta-text');
      (textEl || cta).insertAdjacentElement('afterend', priceEl);
    }
    const setPrice = () => {
      if (!priceEl) return;
      const v = current();
      const p = v ? v.p : D.price;
      const c = v ? v.c : '';
      const html = cta.disabled ? '' : '· ' + (c ? '<s>' + esc(c) + '</s> ' : '') + esc(p);
      if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
    };

    /* 2. shade label */
    const setLabel = () => {
      if (!D.single) return;
      const v = current();
      if (!v) return;
      root.querySelectorAll('variant-swatch-king .swatch-label').forEach((lab) => {
        const html = esc(D.t.shade) + ': <b>' + esc(v.v) + '</b>' + (v.d ? ', ' + esc(v.d) : '');
        let out = lab.querySelector('.teeez-shade-label');
        if (!out) {
          out = document.createElement('span');
          out.className = 'teeez-shade-label';
          lab.appendChild(out);
          lab.classList.add('teeez-has-shade-label');
        }
        if (out.innerHTML !== html) out.innerHTML = html;
      });
    };

    /* 3. first photo */
    const swapFirst = (url) => {
      if (!url || !D.first) return;
      root.querySelectorAll('img').forEach((img) => {
        if (img.closest('variant-swatch-king') || img.closest('.teeez-sets')) return;
        const s = ['src', 'srcset', 'data-src', 'data-srcset'].map((a) => img.getAttribute(a) || '').join(' ');
        if (img.dataset.teeezFirst || s.indexOf(D.first) !== -1) {
          img.dataset.teeezFirst = 'true';
          img.removeAttribute('srcset');
          img.removeAttribute('data-srcset');
          img.removeAttribute('sizes');
          img.setAttribute('data-src', url);
          img.src = url;
          img.closest('picture') && img.closest('picture').querySelectorAll('source').forEach((x) => x.remove());
        }
      });
    };
    if (D.single) {
      const stem = (url) => (url.split('?')[0].split('/').pop() || '').replace(/\.[a-z0-9]+$/i, '');
      const firstIsSoldOut = ids.some((id) => {
        const v = D.variants[id];
        if (v.a || !v.img) return false;
        const s = stem(v.img);
        return s && (D.first === s || D.first.indexOf(s + '_') === 0);
      });
      const v = current();
      if (firstIsSoldOut && v && v.img) swapFirst(v.img);
    }

    /* 4. sets follow the shade */
    const setSets = () => {
      const v = current();
      if (!v || !D.single) return;
      root.querySelectorAll('[data-teeez-set]').forEach((a) => {
        a.href = a.dataset.base + '?teeez_shade=' + encodeURIComponent(v.v);
        a.querySelectorAll('.teeez-set__shade').forEach((s) => { s.textContent = v.v; });
        if (a.dataset.combo) {
          try {
            const map = JSON.parse(a.dataset.combo);
            const img = a.querySelector('.teeez-set__img');
            if (map[v.v] && img) img.src = map[v.v];
          } catch (e) {}
        }
      });
    };

    /* 5. sticky bar on phones */
    let bar = null;
    if (cta && window.matchMedia('(max-width: 767px)').matches) {
      bar = document.createElement('div');
      bar.className = 'teeez-sticky-atb';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span class="teeez-sticky-atb__dot"></span><span class="teeez-sticky-atb__name"><span class="teeez-sticky-atb__shade"></span><small>' + esc(D.title) + '</small></span><button type="button" class="teeez-sticky-atb__btn" tabindex="-1"></button>';
      document.body.appendChild(bar);
      bar.querySelector('button').addEventListener('click', () => cta.click());
      const header = document.querySelector('.header--root');
      const footer = document.querySelector('.shopify-section-group-footer-group, footer');
      const update = () => {
        const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const r = cta.getBoundingClientRect();
        const ft = footer ? footer.getBoundingClientRect().top : Infinity;
        bar.classList.toggle('is-on', r.bottom < top && ft > window.innerHeight - 40);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    const setBar = () => {
      if (!bar) return;
      const v = current();
      const dot = bar.querySelector('.teeez-sticky-atb__dot');
      bar.querySelector('.teeez-sticky-atb__shade').textContent = v && D.single ? v.v : D.title;
      bar.querySelector('small').style.display = v && D.single ? '' : 'none';
      dot.style.display = v && D.single && v.sk ? '' : 'none';
      if (v && v.sk) dot.style.backgroundImage = 'url("' + v.sk + '")';
      const text = cta.querySelector('.product-buy-buttons--cta-text');
      const bh = esc(text ? text.textContent.trim() : D.t.add) + (priceEl && priceEl.innerHTML ? ' ' + priceEl.innerHTML : '');
      if (bar.querySelector('button').innerHTML !== bh) bar.querySelector('button').innerHTML = bh;
      bar.querySelector('button').disabled = cta.disabled;
    };

    let last = null;
    const refresh = () => {
      setPrice();
      setLabel();
      const id = select ? select.value : null;
      if (id !== last) {
        if (last !== null) {
          const v = current();
          if (v && v.img && D.single) swapFirst(v.img);
        }
        last = id;
        setSets();
      }
      setBar();
    };
    refresh();
    /* the theme and Swatch King change the selected variant and the button text; follow them */
    const mo = new MutationObserver(() => { clearTimeout(mo.t); mo.t = setTimeout(refresh, 40); });
    mo.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class', 'selected'] });
    root.addEventListener('change', () => setTimeout(refresh, 60));
    root.addEventListener('click', () => setTimeout(refresh, 150));

    /* 6. preselect a shade on bundle pages */
    const want = new URLSearchParams(location.search).get('teeez_shade');
    if (want && D.bundle) {
      const pick = (tries) => {
        const input = Array.from(root.querySelectorAll('product-options-root input[type="radio"]')).find((i) => i.value === want);
        if (input) {
          if (!input.checked) {
            const label = root.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            (label || input).click();
          }
          return;
        }
        if (tries > 0) setTimeout(() => pick(tries - 1), 250);
      };
      pick(12);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
